import store from "@/store/";

export default async ({ from, to, next }) => {
  let possibleQueries = {
    campaign: "subscription/setCampaign",
    promo: "subscription/setPromo",
    sponsor: "subscription/setSponsorCustomerId",
    agentCheckEan: "subscription/setAgentCheckEan"
  };

  for (const query in to.query) {
    if (possibleQueries[query] !== undefined) {
      let value = to.query[query];
      await store.commit(possibleQueries[query], value, { root: true });

      delete to.query[query];
    }
  }
  
  if(Object.keys(to.query).length === 0) {
    console.log('middleware - get');
    return next({ path: to.path, query: to.query })
  }

  return next();
};



// WEBPACK FOOTER //
// ./src/router/middleware/get.js